<span class="pastille" aria-hidden="true"></span>
<span class="icone material-symbols-outlined" aria-hidden="true">{{ carte().icone }}</span>
<h3>{{ carte().libelle }}</h3>
<span class="marque">{{ carte().marque || 'Marque non renseignée' }}</span>
<span class="sr-only">{{ carte().etat.libelle }}</span>
@if (carte().ticketsParDefaut.length > 0) {
  <button
    type="button"
    class="tickets-toggle"
    [matMenuTriggerFor]="ticketsMenu"
    [attr.aria-label]="
      'Voir les ' +
      carte().nombreTickets +
      ' tickets de ' +
      carte().libelle +
      ' — ' +
      carte().etat.libelle
    "
  >
    <span class="sr-only">Tickets ({{ carte().nombreTickets }})</span>
    <span class="material-symbols-outlined" aria-hidden="true">expand_more</span>
  </button>
  <mat-menu #ticketsMenu="matMenu" class="materiel-tickets-menu" [overlapTrigger]="false">
    <div class="menu-entete">
      <strong>{{ carte().libelle }}</strong>
      <span
        >{{ carte().nombreTickets }}
        {{ carte().nombreTickets === 1 ? 'ticket associé' : 'tickets associés' }}</span
      >
    </div>
    @for (groupe of carte().ticketsParDefaut; track groupe.type) {
      <div class="type-defaut">{{ groupe.libelle }}</div>
      @for (ticket of groupe.tickets; track ticket) {
        <a
          mat-menu-item
          class="ticket-lien"
          [routerLink]="['/ticket', ticket]"
          [attr.aria-label]="
            'Voir le ticket #' + ticket + ' — ' + groupe.libelle + ' — ' + carte().libelle
          "
        >
          Ticket #{{ ticket }}
        </a>
      }
    }
  </mat-menu>
}
